import AuthFooter from './Auth-Footer';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { verifyNumberOTP, authState, setVerifyNumberResponse } from '../../slices/slices/AuthSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { AuthenticationSchema } from '../common/Validation';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { Link } from 'react-router-dom';
import Label from '../../components/Label';
import { RemoveCookie } from '../../services/cookies';

const Authentication = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { numberVerifyResponse } = useSelector(authState);

  const handleFormSubmit = (values, { setErrors }) => {
    dispatch(verifyNumberOTP(values, setErrors));
  };

  const login = () => {
    RemoveCookie('token');
    navigate('/login');
  };

  useEffect(() => {
    if (numberVerifyResponse.message) {
      navigate('/dashboard');
    }
    dispatch(setVerifyNumberResponse({}));
  }, [numberVerifyResponse.message]);

  return (
    <div className="influence-account-page">
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4">
                  <a href="" className="logo d-flex align-items-center w-auto">
                    <img src="images/logo.png" alt="" />
                  </a>
                </div>
                <div className="card mb-3 loginarea au_thenticator">
                  <div className="card-body">
                    <Formik
                      initialValues={{
                        token: ''
                      }}
                      validationSchema={AuthenticationSchema}
                      onSubmit={handleFormSubmit}
                    >
                      {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
                        <form onSubmit={handleSubmit} className="row needs-validation" noValidate>
                          <div className="col-12 d-flex flex-row justify-content-center textintro btmgap digital">
                            <img
                              className="authenticator"
                              src="images/mobile-icon.png"
                              alt="Authentcator Code"
                            />
                            <Label>Enter the 6-digit code found in your authenticator app</Label>
                          </div>
                          <div className="col-12">
                            <div className="input-group has-validation">
                              <Input
                                type="text"
                                name="token"
                                placeholder="Authentication Code"
                                className="form-control"
                                id="yourUsername"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.token}
                                required
                              />
                              <div className="invalid-feedback">Please enter your username.</div>
                            </div>
                            <span className="error" style={{ color: 'red', fontSize: '20px' }}>
                              {errors.token}
                            </span>
                          </div>
                          <div className="col-12 topgap btnarea justify-content-center">
                            <Button className="btn btn-primary" type="submit">
                              Confirm
                            </Button>
                          </div>
                          <div className="col-12 justify-content-center middletext">
                            <p className="topspace">
                              <a
                                href="/login"
                                onClick={() => {
                                  login();
                                }}
                              >
                                Back to Login
                              </a>
                            </p>
                            <p className="topspace">
                              <Link to="/authentication-email">
                                Use another authentication method
                              </Link>
                            </p>
                          </div>
                        </form>
                      )}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooter />
    </div>
  );
};

export default Authentication;
